import { getFileName, getLivingArea } from '../utils/utils.js';
import { currentUser, objects, brfListLoading } from '../store/store.js';

class BRFObject {
    constructor({id, name, numberOfApartments, ownsTheLand, rentForLand, totalAmountOfLoans, landArea, riskForFeeIncrease, annualFeeIncome, livingFeePerSqm, 
        year, fileName, savingPerSqm, energyCostPerSqm, totalFixedAssets, totalCurrentAssets, otherRevenues, genuineHouseAssociation, fundForExterior,
        netRevenue, profitAfterFinancialItems, taxeringsValue, totalOperatingExpenses, equityRatio, liquidity, ageOfAssociation, ebit, completedRenovation,
        livingAreaSqm, commercialAreaSqm, incomeDrivenProperties, rentalIncomeFromCommercialPremises, upcomingRenovation, cashFlow, assessedValueOfTheLand,
        analyzed, number_of_rental_apartments, municipality, addresses, kassaOchBank, otherReceivables, cashAtTheBeginningOfTheyear,
        cashAtTheEndOfTheYear, rawAttic, parkingSpots, bikeStorage, skattekonto, klientmedel, hasEnergy, hasNotAnalyzedEnergy, rating, coreId}) {
        this.id = id;
        this.name = name;
        this.numberOfApartments = numberOfApartments;
        this.ownsTheLand = ownsTheLand;
        this.rentForLand = rentForLand;
        this.totalAmountOfLoans = totalAmountOfLoans;
        this.landArea = landArea;
        this.riskForFeeIncrease = riskForFeeIncrease;
        this.annualFeeIncome = annualFeeIncome;
        this.livingFeePerSqm = livingFeePerSqm;
        this.year = year;
        this.fileName = getFileName(fileName);
        this.savingPerSqm = savingPerSqm;
        this.energyCostPerSqm = energyCostPerSqm;
        this.totalFixedAssets = totalFixedAssets;
        this.totalCurrentAssets = totalCurrentAssets;
        this.otherRevenues = otherRevenues;
        this.genuineHouseAssociation = genuineHouseAssociation;
        this.fundForExterior = fundForExterior;
        this.netRevenue = netRevenue;
        this.profitAfterFinancialItems = profitAfterFinancialItems;
        this.taxeringsValue = taxeringsValue;
        this.totalOperatingExpenses = totalOperatingExpenses;
        this.equityRatio = equityRatio;
        this.liquidity = liquidity;
        this.ageOfAssociation = ageOfAssociation;
        this.ebit = ebit;
        this.completedRenovation = completedRenovation;
        this.livingAreaSqm = getLivingArea(livingAreaSqm, annualFeeIncome, livingFeePerSqm);
        this.commercialAreaSqm = commercialAreaSqm;
        this.incomeDrivenProperties = incomeDrivenProperties;
        this.rentalIncomeFromCommercialPremises = rentalIncomeFromCommercialPremises;
        this.upcomingRenovation = upcomingRenovation;
        this.cashFlow = cashFlow;
        this.assessedValueOfTheLand = assessedValueOfTheLand;
        this.analyzed = analyzed;
        this.number_of_rental_apartments = number_of_rental_apartments;
        this.municipality = municipality;
        this.addresses = addresses;
        this.kassaOchBank = kassaOchBank;
        this.otherReceivables = otherReceivables;
        this.cashAtTheBeginningOfTheyear = cashAtTheBeginningOfTheyear;
        this.cashAtTheEndOfTheYear = cashAtTheEndOfTheYear;
        this.rawAttic = rawAttic;
        this.parkingSpots = parkingSpots;
        this.bikeStorage = bikeStorage;
        this.skattekonto = skattekonto;
        this.klientmedel = klientmedel;
        this.hasEnergy = hasEnergy;
        this.hasNotAnalyzedEnergy = hasNotAnalyzedEnergy;
        this.rating = rating;
        this.coreId = coreId;
    }
}	
    
    // Search for BRF
	export async function fetchBrfs(search_string = "") {
		try {
			brfListLoading.set(true);
			const response = await fetch('https://boanalys-backend-324523837899.europe-north1.run.app/search_for_brfs?search_string=' + search_string, {
				headers: {
					'Authorization': `Bearer ${currentUser?.accessToken}`
				}
			});
			if (!response.ok) {
				throw new Error('Misslyckades att hämta lista på bostadsrättsföreningar.');
			}
			const data = await response.json();
			
			// This is likely the issue - you're returning an object with status and data
			// but your code expects just the array directly
			const brfArray = Array.isArray(data) ? data : (data.data || []);
			
			// Update the store with the array
			objects.update(() => {
				const result = [];
				for (let i = 0; i < brfArray.length; i++) {
					const [name, analyzed, addresses, coreId, fileName, municipality] = brfArray[i];
					let object = new BRFObject({
						name,
						analyzed,
						addresses: Array.isArray(addresses) ? addresses : [],
						coreId,
						fileName
					});

					if (object.addresses.length === 0 && municipality) {
						object.addresses = typeof municipality === 'string' ? municipality.split(',') : [municipality];
					}

					result.push(object);
				}
				return result;
			});
			
			brfListLoading.set(false);
		} catch (error) {
			console.error('Error fetching items:', error);
			brfListLoading.set(false);
			objects.update(() => []); // Set to empty array on error
		} 
	}

